import React, { useCallback } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import {
  ChangeHistory,
  Circle,
  Close,
  CropSquare,
  Hexagon,
  Pentagon,
  Rectangle,
  Square,
  Star,
  StarBorder,
  Stop,
} from '@mui/icons-material';

dayjs.extend(utc);
dayjs.extend(timezone);

const icons = [
  <Circle sx={{ fontSize: 20, color: '#0909c5ff' }} />,
  <Square sx={{ fontSize: 20, color: '#008000' }} />,
  <Stop sx={{ fontSize: 20, color: '#4B0082' }} />,
  <Pentagon sx={{ fontSize: 20, color: '#71bb10ff' }} />,
  <Square sx={{ fontSize: 20, color: '#db0404ff', transform: 'rotate(45deg)' }} />,
  <Hexagon sx={{ fontSize: 20, color: '#07abadff' }} />,
  <Star sx={{ fontSize: 20, color: '#b69b04ff' }} />,
  <ChangeHistory sx={{ fontSize: 20, color: '#FFA500' }} />,
  <Close sx={{ fontSize: 20, color: '#7c7c7cff' }} />,
  <CropSquare sx={{ fontSize: 20, color: '#A52A2A' }} />,
  <StarBorder sx={{ fontSize: 20, color: '#EE82EE' }} />,
  <Rectangle sx={{ fontSize: 20, color: '#FF1493' }} />,
];

export const useDoctorAgenda = () => {
  const dayjsBrazil = useCallback((date?: dayjs.ConfigType) => {
    return dayjs(date).tz('America/Sao_Paulo');
  }, []);

  const getBrazilianDateISO = useCallback(
    (date: Date) => dayjsBrazil(date).format('YYYY-MM-DD'),
    [dayjsBrazil]
  );

  return { icons, getBrazilianDateISO, dayjsBrazil };
};
